const EDGE_MARGIN = 8;
const CARET_INSET = 12;
const TRIGGER_GAP = 12;

/** @type {HTMLElement | null} */
let hoveredTrigger = null;
/** @type {HTMLElement | null} */
let focusedTrigger = null;

/** @param {HTMLElement} trigger */
const positionTooltip = (trigger) => {
  const popup = /** @type {HTMLElement | null} */ (
    trigger.querySelector(".bp-tooltip-popup")
  );
  if (!popup) return;

  const triggerRect = trigger.getBoundingClientRect();
  const popupRect = popup.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  const triggerCenter = triggerRect.left + triggerRect.width / 2;
  const idealLeft = triggerCenter - popupRect.width / 2;
  const maxLeft = viewportWidth - popupRect.width - EDGE_MARGIN;
  const left = Math.max(EDGE_MARGIN, Math.min(idealLeft, maxLeft));

  const caretLeft = Math.max(
    CARET_INSET,
    Math.min(triggerCenter - left, popupRect.width - CARET_INSET),
  );

  const spaceAbove = triggerRect.top - TRIGGER_GAP;
  const shouldFlip = spaceAbove - popupRect.height < EDGE_MARGIN;

  popup.style.setProperty("--bp-tooltip-left", `${left}px`);
  popup.style.setProperty("--bp-tooltip-caret-left", `${caretLeft}px`);

  if (shouldFlip) {
    popup.style.setProperty(
      "--bp-tooltip-top",
      `${triggerRect.bottom + TRIGGER_GAP}px`,
    );
    popup.style.removeProperty("--bp-tooltip-bottom");
    popup.setAttribute("data-flipped", "");
  } else {
    popup.style.setProperty(
      "--bp-tooltip-bottom",
      `${viewportHeight - triggerRect.top + TRIGGER_GAP}px`,
    );
    popup.style.removeProperty("--bp-tooltip-top");
    popup.removeAttribute("data-flipped");
  }
};

const triggers = /** @type {NodeListOf<HTMLElement>} */ (
  document.querySelectorAll(".bp-tooltip-trigger")
);

triggers.forEach((trigger) => {
  trigger.addEventListener("mouseenter", () => {
    hoveredTrigger = trigger;
    positionTooltip(trigger);
  });
  trigger.addEventListener("mouseleave", () => {
    if (hoveredTrigger === trigger) hoveredTrigger = null;
  });

  trigger.addEventListener("focus", () => {
    focusedTrigger = trigger;
    positionTooltip(trigger);
  });
  trigger.addEventListener("blur", () => {
    if (focusedTrigger === trigger) focusedTrigger = null;
  });

  trigger.addEventListener("click", (event) => {
    if (event.target instanceof Element && event.target.closest("a")) return;
    event.preventDefault();
    event.stopPropagation();
  });
});

const repositionActiveTriggers = () => {
  if (hoveredTrigger) positionTooltip(hoveredTrigger);
  if (focusedTrigger && focusedTrigger !== hoveredTrigger) {
    positionTooltip(focusedTrigger);
  }
};

window.addEventListener("scroll", repositionActiveTriggers, {
  passive: true,
  capture: true,
});

window.addEventListener("resize", repositionActiveTriggers, {
  passive: true,
});
